import React from 'react';
import { Typography, Button, Box, Grid, Container } from '@mui/material';
import {Card,CardContent,CardActions,CardMedia} from '@mui/material';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import { dataBlock } from '../../data/Carrier';

const BlockBox = styled(Box)(({theme}) => ({
    backgroundColor:theme.palette.primary.light,
    color:theme.palette.comman.main,
    paddingBottom:theme.spacing(20),
  }));

const Discuss = () => {
  return (
    <React.Fragment>
    <BlockBox>
    <Grid container>
    {dataBlock.map((item)=>
    <Grid item xs={12} md={4} key={item.id}>
    <Card sx={{textAlign:"center",bgcolor:'transparent',boxShadow:'none'}}>
      <CardMedia
        sx={{ height: 250 }}
        image={item.img}
        title={item.imgAlt}
        alt={item.imgAlt}
      />
      <CardContent>
      <Avatar sx={{mb:2,bgcolor:'primary.main',mx:'auto'}}>{item.id}</Avatar>
        <Typography variant="h5" color="comman.main">
        {item.title}
        </Typography>
        <Typography variant="body2" color="text.main">
        {item.text}
        </Typography>
      </CardContent>
    </Card>
    </Grid>
    )}
    </Grid>
    </BlockBox>
    </React.Fragment>
  )
}

export default Discuss